import {
    Button, Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Box, Stepper, Step, StepLabel, CircularProgress,
    Alert, IconButton, Divider, Typography, Chip, Tabs, Tab
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import CloseIcon from '@mui/icons-material/Close'
import VisibilityIcon from '@mui/icons-material/Visibility'
import EditIcon from '@mui/icons-material/Edit'
import { useState } from 'react'
import Swal from 'sweetalert2'
import { useAppServices } from 'hook/services'
import Editor from 'components/editor'

const steps = ['Enter Prompt', 'Review & Edit', 'Save Blog']

const initialForm = {
    title: '',
    slug: '',
    metaDescription: '',
    featuredImageAlt: '',
    canonicalUrl: '',
    body: '',
    author: 'Aloca Team',
}

const BlogPreview = ({ form }) => (
    <Box sx={{
        fontFamily: '"Georgia", serif',
        backgroundColor: '#fff',
        borderRadius: '8px',
        border: '1px solid #e0e0e0',
        overflow: 'hidden',
    }}>


        {/* Blog article — same styling as live site */}
        <Box sx={{ maxWidth: 780, mx: 'auto', px: { xs: 2, md: 5 }, py: 4 }}>
            <Box display="flex" alignItems="center" gap={1.5} mb={2} flexWrap="wrap">
                <Chip label="Blog" size="small" sx={{ backgroundColor: '#1A73E8', color: 'white', fontSize: '0.7rem', fontWeight: 700 }} />
                <Typography variant="caption" sx={{ color: '#777', fontSize: '0.78rem' }}>
                    By {form.author || 'Aloca Team'}
                </Typography>
                <Typography variant="caption" sx={{ color: '#aaa', fontSize: '0.78rem' }}>
                    · {new Date().toLocaleDateString('en-AU', { day: '2-digit', month: 'long', year: 'numeric' })}
                </Typography>
            </Box>

            <Box
                sx={{

                }}
                dangerouslySetInnerHTML={{
                    __html: form.body || '<p style="color:#aaa">Your blog content will appear here...</p>'
                }}
            />


        </Box>
    </Box>
)

export default function CreateBlogModal({ handleRefresh }) {
    const [open, setOpen] = useState(false)
    const [activeStep, setActiveStep] = useState(0)
    const [prompt, setPrompt] = useState('')
    const [generating, setGenerating] = useState(false)
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')
    const [form, setForm] = useState(initialForm)
    const [tab, setTab] = useState(0)
    const [editorKey, setEditorKey] = useState(0)
    const AppService = useAppServices()

    const handleOpen = () => {
        setOpen(true)
        setActiveStep(0)
        setPrompt('')
        setForm(initialForm)
        setError('')
        setTab(0)
    }

    const handleClose = () => setOpen(false)

    const handleChange = (field) => (e) =>
        setForm((prev) => ({ ...prev, [field]: e.target.value }))

    const handleEditorChange = (data) =>
        setForm((prev) => ({ ...prev, body: data }))

    const handleGenerate = async () => {
        if (!prompt.trim()) { setError('Please enter a topic prompt.'); return }
        setError('')
        setGenerating(true)
        try {
            const payload = { prompt }
            const { response } = await AppService.blogs.generate_blog({ payload })
            console.log('generated:', response.blog)
            const blog = response?.blog
            setForm({
                title: blog?.title || '',
                slug: blog?.slug || '',
                metaDescription: blog?.metaDescription || '',
                featuredImageAlt: blog?.featuredImageAlt || '',
                canonicalUrl: blog?.canonicalUrl || '',
                body: blog?.body || '',
                author: 'Aloca Team',

            })
            setEditorKey((k) => k + 1)
            setActiveStep(1)
            setTab(1)
        } catch (err) {
            console.error(err)
            setError('Failed to generate blog. Please try again.')
        } finally {
            setGenerating(false)
        }
    }

    const handleSave = async (status = 'draft') => {
        if (!form.title || !form.body) { setError('Title and Body are required.'); return }
        setSaving(true)
        setError('')
        try {
            const payload = { ...form, prompt, status }
            await AppService.blogs.create({ payload })
            setOpen(false)
            handleRefresh()
            Swal.fire({
                icon: 'success',
                title: status === 'published' ? 'Blog Published!' : 'Draft Saved!',
                text: status === 'published' ? 'Your blog is now live.' : 'Blog saved as draft successfully.',
                timer: 2500,
                showConfirmButton: false,
            })
        } catch (err) {
            setError('Failed to save blog. Please try again.')
        } finally {
            setSaving(false)
        }
    }

    return (
        <>
            {/* <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleOpen}
                sx={{
                    backgroundColor: '#f0f4ff',
                    color: '#1A73E8',
                    fontWeight: 700,
                    fontSize: '0.8rem',
                    borderRadius: '8px',
                    textTransform: 'none',
                    px: 2,
                    '&:hover': { backgroundColor: '#dce8ff' },
                }}
            >
                Create Blog
            </Button> */}

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth={activeStep === 1 ? 'lg' : 'md'}
                fullWidth
                PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}
            >
                {/* Header */}
                <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #1A73E8 0%, #0D47A1 100%)',
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    py: 2, px: 3,
                }}>
                    {/* <Box display="flex" alignItems="center" gap={1}>
                        <AutoAwesomeIcon color='white' sx={{ fontSize: 20, color: 'white' }} />
                        <Typography variant="h6" fontWeight={700} style={{ color: "white" }} fontSize="1rem" color="white">
                            Create New Blog
                        </Typography>
                    </Box> */}
                    <IconButton onClick={handleClose} sx={{ color: 'white' }} size="small">
                        <CloseIcon color='white' />
                    </IconButton>
                </DialogTitle>

                {/* Stepper */}
                <Box px={4} pt={3} pb={1} sx={{ backgroundColor: '#f8faff' }}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel sx={{ '& .MuiStepLabel-label': { fontSize: '0.78rem', fontWeight: 600 } }}>
                                    {label}
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>

                {/* ── DialogContent — both steps live HERE ── */}
                <DialogContent sx={{ px: 4, py: 3 }}>
                    {error && (
                        <Alert severity="error" sx={{ mb: 2, borderRadius: '8px' }}>{error}</Alert>
                    )}

                    {/* STEP 0 */}
                    {activeStep === 0 && (
                        <Box>
                            <Typography variant="body2" color="text.secondary" mb={2}>
                                Enter a topic and let AI generate a full SEO blog
                            </Typography>
                            <TextField
                                label="Blog Topic / Prompt"
                                placeholder="e.g. Best photoshoot locations in Melbourne"
                                fullWidth multiline rows={10}
                                value={prompt}
                                onChange={(e) => setPrompt(e.target.value)}
                                sx={{ mb: 2 }}
                            />
                            <Button
                                variant="contained"
                                startIcon={generating
                                    ? <CircularProgress size={16} color="inherit" />
                                    : <AutoAwesomeIcon />
                                }
                                onClick={handleGenerate}
                                disabled={generating}
                                sx={{
                                    background: 'linear-gradient(135deg, #1A73E8, #0D47A1)',
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    color: 'white',
                                }}
                                style={{ color: "white" }}
                            >
                                {generating ? 'Generating...' : 'Generate with AI'}
                            </Button>
                        </Box>
                    )}

                    {/* STEP 1 — Edit + Preview */}
                    {activeStep === 1 && (
                        <Box>
                            {/* Tab header */}



                            {tab === 0 && (
                                <Box display="flex" flexDirection="column" gap={2}>
                                    <TextField
                                        label="Title (≤60 chars)" fullWidth
                                        value={form.title} onChange={handleChange('title')}
                                        inputProps={{ maxLength: 60 }}
                                        helperText={`${form.title.length}/60`}
                                    />
                                    <TextField
                                        label="Slug" fullWidth
                                        value={form.slug} onChange={handleChange('slug')}
                                        helperText="lowercase-hyphenated"
                                    />
                                    <TextField
                                        label="Meta Description (≤150 chars)" fullWidth
                                        value={form.metaDescription} onChange={handleChange('metaDescription')}
                                        inputProps={{ maxLength: 150 }}
                                        helperText={`${form.metaDescription.length}/150`}
                                    />
                                    <Box display="flex" gap={2}>
                                        <TextField
                                            label="Featured Image Alt" fullWidth
                                            value={form.featuredImageAlt} onChange={handleChange('featuredImageAlt')}
                                        />
                                        <TextField
                                            label="Author" fullWidth
                                            value={form.author} onChange={handleChange('author')}
                                        />
                                    </Box>
                                    <TextField
                                        label="Canonical URL" fullWidth
                                        value={form.canonicalUrl} onChange={handleChange('canonicalUrl')}
                                    />

                                    <Divider />

                                    <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ letterSpacing: 1 }}>
                                        BLOG BODY
                                    </Typography>

                                    {/* Rich HTML Editor — receives HTML, emits HTML */}
                                    <Box sx={{
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '8px',
                                        overflow: 'hidden',
                                        '& .ck-editor__editable': { minHeight: 380, fontSize: '0.95rem', px: 2 },
                                        '& .ck.ck-toolbar': { borderRadius: '8px 8px 0 0 !important' },
                                    }}>
                                        <Editor
                                            key={editorKey}
                                            data={form.body}
                                            handleChange={handleEditorChange}
                                        />
                                    </Box>

                                    <Button
                                        size="small"
                                        variant="outlined"
                                        startIcon={<VisibilityIcon />}
                                        onClick={() => setTab(1)}
                                        sx={{ alignSelf: 'flex-start', borderRadius: '8px', textTransform: 'none', fontWeight: 600, background: "blue" }}
                                    >
                                        Switch to Live Preview
                                    </Button>
                                </Box>
                            )}

                            {tab === 1 && (
                                <Box>
                                    <Box display="flex" justifyContent="flex-end" mb={1.5}>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            startIcon={<EditIcon />}
                                            onClick={() => setTab(0)}
                                            sx={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600, backgroundColor: "blue" }}
                                        >
                                            Back to Edit
                                        </Button>
                                    </Box>
                                    <BlogPreview form={form} />
                                </Box>
                            )}
                        </Box>
                    )}
                </DialogContent>

                {/* Actions */}
                <DialogActions sx={{ px: 4, pb: 3, gap: 1 }}>
                    {activeStep === 0 && (
                        <Button onClick={handleClose} sx={{ textTransform: 'none' }}>Cancel</Button>
                    )}
                    {activeStep === 1 && (
                        <>
                            <Button onClick={() => setActiveStep(0)} sx={{ textTransform: 'none' }}>
                                Back
                            </Button>
                            <Box flex={1} />
                            <Button
                                variant="outlined"
                                onClick={() => handleSave('draft')}
                                disabled={saving}
                                sx={{
                                    background: 'linear-gradient(135deg, #1A73E8, #0D47A1)',
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    color: 'white',
                                }}
                            >
                                {saving ? <CircularProgress size={16} /> : 'Save as Draft'}
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => handleSave('published')}
                                disabled={saving}
                                style={{ color: 'white' }}
                                sx={{
                                    background: 'linear-gradient(135deg, #1A73E8, #0D47A1)',
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    color: 'white',
                                }}
                            >
                                {saving ? <CircularProgress size={16} color="inherit" /> : 'Publish Now'}
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </>
    )
}
